// extracted by mini-css-extract-plugin
module.exports = {"info":"CharitySummary_info__vkIkc","header":"CharitySummary_header__T_Son"};